// ** react imports
import React from 'react';

// ** router imports
import { Link, useSearchParams } from 'react-router-dom';

// ** context imports
import {
  TaxFileDetailsProvider,
  useTaxFileDetails,
} from '../../../contexts/TaxFileDetailsContext';

// ** components imports
import Loading from '../../../components/common/Loading';
import CustomerInformationSection from '../../../components/taxFile/details/CustomerInformationSection';
import OverallProgressSection from '../../../components/taxFile/details/OverallProgressSection';
import QuizResponseSection from '../../../components/taxFile/details/QuizResponseSection';
import InOfficeDocumentsSection from '../../../components/taxFile/details/InOfficeDocumentsSection';

// ** enums imports
import { TAX_FILE_TYPE } from '../../../enums/common';

function TaxFileDetailsContent() {
  // hooks
  const [searchParams] = useSearchParams();
  const taxFileType = searchParams.get('type');

  const { taxFile, isGetTaxFileLoading, isGetQuizResponseByTaxFileIdLoading } =
    useTaxFileDetails();

  return (
    <div className="flex">
      <main className="grow">
        <div className="px-4 sm:px-6 lg:px-8 py-6 w-full max-w-[96rem] mx-auto">
          <div className="mb-8">
            <div className="mb-8">
              <ul className="inline-flex flex-wrap items-center text-sm font-medium">
                <li className="flex items-center">
                  <Link
                    to="/"
                    className="text-gray-500 dark:text-gray-400 hover:text-violet-500 dark:hover:text-violet-500"
                  >
                    Home
                  </Link>
                  <svg
                    className="fill-current text-gray-400 dark:text-gray-600 mx-3"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                  </svg>
                </li>
                <li className="flex items-center">
                  <Link
                    to="/tax-files/list"
                    className="text-gray-500 dark:text-gray-400 hover:text-violet-500 dark:hover:text-violet-500"
                  >
                    Tax Files
                  </Link>
                  <svg
                    className="fill-current text-gray-400 dark:text-gray-600 mx-3"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                  >
                    <path d="M6.6 13.4L5.2 12l4-4-4-4 1.4-1.4L12 8z" />
                  </svg>
                </li>
                <li className="flex items-center">
                  <span className="text-gray-800 dark:text-gray-100">
                    Details
                  </span>
                </li>
              </ul>
            </div>

            <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">
              Tax File Details
            </h1>
            {taxFile ? (
              <p className="text-gray-600 dark:text-gray-400 mt-1">
                ID #{taxFile.referenceNumber}
              </p>
            ) : (
              <p className="text-gray-600 dark:text-gray-400 mt-1">ID #N/A</p>
            )}
          </div>

          <div className="relative">
            {(isGetQuizResponseByTaxFileIdLoading || isGetTaxFileLoading) && (
              <div className="absolute inset-0 bg-white/50 dark:bg-gray-800/50 backdrop-blur-sm z-40 flex items-center justify-center rounded-xl">
                <div className="flex items-center gap-3 text-gray-600 dark:text-gray-300">
                  <Loading />
                </div>
              </div>
            )}

            <div className="space-y-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6.5">
                <div className="">
                  <CustomerInformationSection taxFile={taxFile} />
                </div>
                <div className="">
                  <OverallProgressSection taxFile={taxFile} />
                </div>
              </div>
              <div className="">
                {taxFileType === TAX_FILE_TYPE.VIRTUAL_INTAKE ? (
                  <QuizResponseSection />
                ) : (
                  <InOfficeDocumentsSection />
                )}
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}

function TaxFileDetailsPage() {
  return (
    <TaxFileDetailsProvider>
      <TaxFileDetailsContent />
    </TaxFileDetailsProvider>
  );
}

export default TaxFileDetailsPage;
